import { render, staticRenderFns } from "./AdmisionInscritosModalidadB.vue?vue&type=template&id=e83141d8"
import script from "./AdmisionInscritosModalidadB.vue?vue&type=script&lang=js"
export * from "./AdmisionInscritosModalidadB.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports